// extracted by mini-css-extract-plugin
var _1 = "BirdviewAttentionRow-modulerow__VugQQ";
export { _1 as "row" }
